import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/student/NgoScreen/NgoHero.css';

const HeroSection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleNgoRegister = () => {
    setLoading(true);
    setTimeout(() => {
      navigate('/ngo-auth');
    }, 1500);
  };

  return (
    <section className="hero-section">
      <div className="hero-bg-pattern"></div>
      <Container className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Connecting <span className="hero-title-highlight">Students</span>
            <br />with Verified NGOs
          </h1>
          <p className="hero-subtitle">
            Our platform ensures every donation reaches deserving students
            transparently — verified by trusted NGO partners across Pakistan.
          </p>
          <div className="hero-btn-group">
            <button
              className={`hero-btn-primary ${loading ? 'hero-btn-loading' : ''}`}
              onClick={handleNgoRegister}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="hero-spinner"></span>
                  Loading...
                </>
              ) : (
                'Register as NGO'
              )}
            </button>
            <a href="#how-it-works" className="hero-btn-outline">
              See How It Works
            </a>
          </div>
        </div>
        <div className="hero-image-box">
          <img
            src="https://i.pinimg.com/1200x/61/7b/48/617b4850e24dd0bfa5b6e2553819e51e.jpg"
            alt="Library"
            className="hero-image-box"
          />
        </div>
      </Container>
    </section>
  );
};

export default HeroSection;